import { AccountRecoveryPage } from '@belong/journey-authentication';

export default AccountRecoveryPage;
